import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import UserSelect from '../AppHeader/UserSelect'
import IssueItem from '../Issue/IssueItem'

type Props = {}

const AddKeyToUser = observer((props: Props) => {
  const keyToUser = RootStore.modalsUi.keyToUser
  const open = !!keyToUser

  const selectedUser = RootStore.settingsStore.user

  const hundleClose = () => {
    RootStore.modalsUi.hundleSetAddKeyToUser(undefined)
  }

  if (!keyToUser) return <></>

  const hundleChange = async () => {
    if (!selectedUser) return toast.error('Не выбран пользователь')
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.CreateApiKey({
        value: keyToUser,
        userId: selectedUser?.id,
      })
      toast.update(toastId, {
        render: 'Войдите по ключу еще раз',
        type: 'info',
        isLoading: false,
        ...toastConfig,
      })
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <DialogTitle>Выберите себя из списка и поднесите ключ</DialogTitle>
      <DialogContent>
        <UserSelect notApproved />
      </DialogContent>

      <DialogActions>
        <Button onClick={hundleChange}>Подтвердить</Button>
        <Button onClick={hundleClose}>Отмена</Button>
      </DialogActions>
    </Dialog>
  )
})

export default AddKeyToUser
